<template>
  <div>
    <div class="font py-5 bg-color" >
      <b-container>
        <b-row>
          <b-col cols='5' class='mx-auto'>
            <b-card class='org-session text-center'>
              <h4 class="mb-4 mt-4">新規登録</h4>
              <validation-observer class="form bg-white" ref="obs" >
                <b-row class=" mx-2 mt-2">
                  <b-col class=" mx-auto px-20 text-left">
                    <validation-provider name="email" rules="required">
                      <div slot-scope="mail_adress">
                        <small>メールアドレス</small>
                        <b-input-group class="mt-2 session-input" :class='{"error-input": mail_adress.failed}'>
                          <template #prepend>
                            <b-input-group-text class='session-icon-input'><b-icon icon="envelope-fill"></b-icon></b-input-group-text>
                          </template>
                          <b-form-input placeholder="Email" v-model="email"></b-form-input>
                        </b-input-group>
                        <p v-if="mail_adress.failed" class="error">{{ mail_adress.errors[0] }}</p>
                      </div>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row class=" mx-2 mt-2">
                  <b-col class=" mx-auto px-20 text-left">
                    <validation-provider name="password" rules="required|password">
                      <div slot-scope="passwordScope">
                        <small>パスワード</small>
                        <b-input-group class=" session-input-side" :class='{"error-input": isMiss}'>
                          <template #prepend>
                            <b-input-group-text class='session-icon-input'><b-icon icon="lock-fill"></b-icon></b-input-group-text>
                          </template>
                          <b-form-input :type="inputType" placeholder="Password" v-model="password"></b-form-input>
                          <template #append>
                            <b-input-group-text class='session-icon-input-append'><b-icon :icon="icon" @click="switchPassword"></b-icon></b-input-group-text>
                          </template>
                        </b-input-group>
                        <p v-if="passwordScope.failed" class="error">{{ passwordScope.errors[0] }}</p>
                      </div>
                    </validation-provider>
                    <p class="text-center mt-3 mb-0 text-error" v-if='isMiss'><b>{{$t("message.missPassword")}}</b></p>
                  </b-col>
                </b-row>

                <b-row class=" mx-2 mt-2">
                  <b-col class=" mx-auto px-20 text-left">
                    <validation-provider name="password_confirm" rules="required|confirmed:password" >
                      <div slot-scope="passwordConfirmScope">
                        <small>確認用パスワード</small>
                        <b-input-group class=" session-input-side" :class='{"error-input": isMiss}'>
                          <template #prepend>
                            <b-input-group-text class='session-icon-input'><b-icon icon="lock-fill"></b-icon></b-input-group-text>
                          </template>
                          <b-form-input :type="inputType" placeholder="Password" v-model="passwordConfirm"></b-form-input>
                          <template #append>
                            <b-input-group-text class='session-icon-input-append'><b-icon :icon="icon" @click="switchPassword"></b-icon></b-input-group-text>
                          </template>
                        </b-input-group>
                        <p v-if="passwordConfirmScope.failed" class="error">{{ passwordConfirmScope.errors[0] }}</p>
                      </div>
                    </validation-provider>
                    <p class="text-center mt-3 mb-0 text-error" v-if='isMiss'><b>{{$t("message.missPassword")}}</b></p>
                  </b-col>
                </b-row>

                <b-row class=" mx-2 mt-3">
                  <b-col class=" mx-auto px-20 text-center">
                    <b-form-checkbox v-model="consent">
                      利用規約に同意する
                    </b-form-checkbox>
                    <p v-if='plConcent' >利用規約に同意してください</p>
                  </b-col>
                </b-row>
              </validation-observer>
              <b-row class="pt-3">
                <b-col cols='10' class="mx-auto">
                  <b-button  class="login py-2 px-4 width100" @click="signup" >登録 </b-button>
                </b-col>
              </b-row>

              <p class="mt-3 mb-1">既にアカウントをお持ちの方はこちら</p>
              <b-button @click='changMode()' class="forgot px-0">
                <h5>ログイン</h5>
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal v-model="confirmModal " hide-footer hide-header size="sm">
      <template v-slot:default="{ hide }">
        <div class="row mb-5">
          <div class="col-10 px-0">
            <p class="text-center ml-5 mt-3 mb-0"><b>{{$t("message.account_confirm")}}</b></p>
          </div>
          <div class="col-1 px-0">
            <button class="btn btn-md " @click="hide()"><h3>×</h3></button>
          </div>
        </div>

        <validation-observer class="form bg-white" ref="confirm" >
          <div class="row mt-3">
            <div class="col-12 mx-auto">
              <label ><span class="text-danger">*</span>{{$t("message.account_confirm")}}</label>
              <validation-provider name="confirm" rules="required">
                <div slot-scope="confirmScope">
                  <input  class="dirty b-w-0 p-2 bg-gray width100" v-model="confirmCode" placeholder="ex）1234abcd">
                  <p v-if="confirmScope.failed" class="error">{{ confirmScope.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mt-3 mb-4">
            <div class="col-12 mx-auto">
              <b-button  class="login py-2 px-4 width100" @click="confirm" > {{$t("message.confirm")}} </b-button>
            </div>
          </div>
        </validation-observer>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver} from "vee-validate";
import { Auth } from "aws-amplify";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      isChecked: true,
      inputType: 'password',
      email: "",
      password: "",
      icon: "eye-fill",
      isMiss: false,
      confirmModal: false,
      confirmCode: '',
      passwordConfirm: '',
      consent: false,
      plConcent: false
    }
  },
  mounted(){
    this.$store.commit('setLoading', false)
  },
  methods: {
    changMode(){
      this.$emit('changMode')
    },
    confirm () {
      this.$refs.confirm.validate().then(value =>{
        if(value){
          Auth.confirmSignUp(this.email, this.confirmCode)
            .then(() => {
              this.$swal.fire({
                icon: 'success',
                title: this.$i18n.t('message.do_signup')
              }).then(()=>{
                this.confirmModal = false
                this.changMode()
              })
            })
            .catch(err => {
              console.log('dsfsfdsdf',err)
            })
          }
        })
      .catch(err => {
        console.log(err)
      })
    },
    authGoogle(){
      Auth.federatedSignIn({provider: 'Google'})
    },
    authFacebook(){
      Auth.federatedSignIn({provider: 'Facebook'})
    },
    signup(){
      this.$refs.obs.validate().then(value =>{
        if(value ){
          if(this.consent){
            Auth.signUp({username: this.email, password: this.password, attributes: {email: this.email}})
            .then(() =>{
              this.confirmModal = true
            })
            .catch(error =>{
              console.log('thsi is errors',error)
            })
          }
          else{
            this.plConcent = true
          }
        }
      })
    },
    switchPassword(){
      if (this.isChecked) {
        this.isChecked = false
        this.inputType = "text"
        this.icon = "eye-slash"
      } else {
        this.isChecked = true
        this.inputType = "password"
        this.icon = "eye"
      }
    },
    switchPasswordConfirm(){
      if (this.isCheckedConfirm) {
        this.isCheckedConfirm = false
        this.inputTypeConfirm = "text"
        this.iconConfirm = "eye-slash"
      } else {
        this.isCheckedConfirm = true
        this.inputTypeConfirm = "password"
        this.iconConfirm = "eye"
      }
    },
  }
 }
</script>
<style type="scss" scoped>
.header{
  background-color: #000054;
  height: 65px;
}

.icon{
  height: 35px !important;
}

.bg-color{
  background-color: #f3f3f3;
}

.org-session{
  border-radius: 1.5rem;
}

.forgot{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;
  font-size: 0.8rem;

  &:hover {
    box-shadow: none !important;
  }
}
.text-orange{
  color: #F29147 !important;
}
</style>